<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <template v-slot:prepend>
        <v-icon icon="mdi-home" size="small"></v-icon>
      </template>
    </v-breadcrumbs>

    <v-container class="grey lighten-5">
      <v-row>
        <v-col sm="12" md="12">
          <v-card rounded="xl" elevation="3">
            <v-card-title class="border-bottom">
              <v-row>
                <v-col cols="6">User List</v-col>
                <v-col cols="6" class="text-end">
                  <v-btn color="primary" @click="openUserModal"> <v-icon>mdi-account-edit</v-icon> Add User</v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-table>
                <thead>
                <tr>
                  <th class="text-left">SL</th>
                  <th class="text-left">Name</th>
                  <th class="text-left">Email</th>
                  <th class="text-left">Phone</th>
                  <th width="13%" class="text-center"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="n in 10" :key="n">
                  <td>{{ n }}</td>
                  <td>Abdul Jobbar{{ n }}</td>
                  <td>AbdulJobbar{{ n }}@gmail.com</td>
                  <td>+880170000000{{ n }}</td>
                  <td class="text-nowrap">
                    <v-btn size="small" class="mr-2" color="primary" icon>
                      <v-icon>mdi-account-edit</v-icon>
                      <v-tooltip activator="parent" location="top">Edit</v-tooltip>
                    </v-btn>
                    <v-btn size="small" class="mr-2" color="success" icon>
                      <v-icon>mdi-account-eye</v-icon>
                      <v-tooltip activator="parent" location="top">View Details</v-tooltip>
                    </v-btn>
                    <v-btn size="small" class="mr-2" color="error" icon>
                      <v-icon>mdi-trash-can-outline</v-icon>
                      <v-tooltip activator="parent" location="top">Delete</v-tooltip>
                    </v-btn>
                  </td>
                </tr>
                </tbody>
              </v-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>


    <InsertModal ref="userModal" title="Create User" :width="900">
      <!-- Dynamic Content -->
      <template #modalBody>
        <v-text-field label="Name" variant="outlined"/>
        <v-text-field label="Email" variant="outlined"/>
        <v-select :menu-props="{ zIndex: 10001 }" label="Select State" :items="['California',  'Colorado', 'Florida', 'Georgia', 'Texas', 'Wyoming' ]" variant="outlined" density="comfortable"  menu-icon="mdi-chevron-down"/>
      </template>
      <template #modalFooter>
        <v-row>
          <v-col cols="6" sm="6" md="6">
            <v-btn type="submit" color="primary" block>Save User</v-btn>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-btn variant="outlined" block @click="$refs.userModal.closeModal()">Cancel</v-btn>
          </v-col>
        </v-row>
      </template>

      <!-- Dynamic Footer -->

    </InsertModal>



  </div>
</template>

<script>
import InsertModal from '@/components/shared/InsertModal.vue'

export default {
  name: 'UsersComponent',
  components: {
    InsertModal
  },
  data: () => ({
    breadcrumbs: [
      {
        title: 'Dashboard',
        disabled: false,
        to: '/dashboard',
      },
      {
        title: 'Users',
        disabled: true,
        to: '',
      },
    ],
  }),

  mounted() {
  },
  methods: {
    openUserModal() {
      this.$refs.userModal.openModal()
    }
  }
}
</script>